import { createIndexDBStorage } from '@orionprotocol/storage';

export const asyncKeyValueStorage = createIndexDBStorage('orion');
